import { Button, LoadingIndicator } from '@components';
import React, { useCallback, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { format, isBefore } from 'date-fns';
import { ResgateParcialService } from '@services';
import { StepsResgateSimulacao } from './Steps';
import { TermosResgateSimulacao } from './Terms';
import { DetailsModal } from '../components/DetailsModal';

export const SimulacaoResgateParcialPage = () => {
  const navigate = useNavigate();
  const { matricula, plano, token } = useSelector((state) => state.user.data);
  const { nome } = useSelector((state) => state.user.dadosPessoais);
  const [viewTerms, setViewTerms] = useState(true);
  const [loading, setLoading] = useState(true);
  const [dadosPrevidenciarios, setDadosPrevidenciarios] = useState({});
  const [dadosEmprestimo, setDadosEmprestimo] = useState({});

  const [infoModalIsOpen, setInfoModalIsOpen] = useState(false);
  const [modalTableData, setModalTableData] = useState({});

  const obterDadosResgate = useCallback(async () => {
    const service = new ResgateParcialService();
    const [dadosPrevidenciariosResponse, dadosEmprestimoResponse] =
      await Promise.all([
        service.ObterDadosPrevidenciariosResgate(matricula, plano),
        service.ObterDadosEmprestimoResgate(matricula),
      ]);

    let msgTrava = '';
    // Validação de carencia 60 meses
    if (
      isBefore(
        new Date(),
        new Date(dadosPrevidenciariosResponse.DataLiberacaoCarencia)
      )
    ) {
      msgTrava = `Ainda em período de carência. O resgate parcial poderá ser solicitado a partir de 60 meses contados da inscrição. Data prevista ${format(
        new Date(dadosPrevidenciariosResponse.DataLiberacaoCarencia),
        'dd/MM/yyyy'
      )}. `;
    }
    // Validação de carencia 36 meses
    if (
      isBefore(
        new Date(),
        new Date(dadosPrevidenciariosResponse.DataLiberacaoIndividualCarencia)
      ) &&
      dadosPrevidenciariosResponse.DataLiberacaoIndividualCarencia
    ) {
      msgTrava = `Ainda em período de carência. O resgate parcial poderá ser solicitado a partir de 36 meses contados da efetivação da portabilidade. Data prevista ${format(
        new Date(dadosPrevidenciariosResponse.DataLiberacaoIndividualCarencia),
        'dd/MM/yyyy'
      )}. `;
    }
    setDadosPrevidenciarios({ ...dadosPrevidenciariosResponse, msgTrava });
    setDadosEmprestimo(dadosEmprestimoResponse);
    setLoading(false);
  }, [matricula, plano]);

  useEffect(() => {
    obterDadosResgate();
  }, [obterDadosResgate]);

  return (
    <>
      <Helmet>Forluz - Simulador de resgate parcial</Helmet>
      <h1 className="page-title mb-3">
        <strong>Simulador de resgate parcial</strong>
      </h1>

      <hr className="my-4" />
      <div className="d-flex col-3 col-md-2 col-lg-1 justify-content-center">
        <Button
          className="justify-content-center mb-32"
          transparent
          color="orange"
          icon="arrow_back"
          onClick={() => navigate(-1)}
        >
          Voltar
        </Button>
      </div>
      {!loading ? (
        <div>
          {!dadosPrevidenciarios.msgTrava ? (
            <div>
              {viewTerms ? (
                <TermosResgateSimulacao setViewTerms={setViewTerms} />
              ) : (
                <StepsResgateSimulacao
                  setInfoModalIsOpen={setInfoModalIsOpen}
                  setInfoModal={setModalTableData}
                  setViewTerms={setViewTerms}
                  dadosPrevidenciarios={dadosPrevidenciarios}
                  dadosEmprestimo={dadosEmprestimo}
                  dadosPessoais={{ matricula, plano, token, nome }}
                />
              )}
            </div>
          ) : (
            <div className="card">
              <div className="card-body pb-0">
                <h3 className="ts-20 fw-bold mb-2">Atenção</h3>
                <p className="ts-14 text-muted mb-32">
                  {dadosPrevidenciarios.msgTrava}
                </p>
              </div>
            </div>
          )}
        </div>
      ) : (
        <LoadingIndicator />
      )}

      {infoModalIsOpen && (
        <DetailsModal
          modalIsOpen={infoModalIsOpen}
          setModalIsOpen={setInfoModalIsOpen}
          infosData={modalTableData}
          dadosPrevidenciarios={dadosPrevidenciarios}
          dadosEmprestimo={dadosEmprestimo}
        />
      )}
    </>
  );
};
